import { Config, Locale, StoreState } from 'app/state/types'
import { parse } from 'query-string'
import { createCombinedSelector } from '../utils/selectorUtils'
import { ShoppingCart } from 'app/types/common-types'

export default createCombinedSelector({
    name: 'getAuthoriseStep',
    state: ['locale', 'config', 'cart', 'router', 'paymentParams'],
    fn: getAuthoriseStepInternal,
})

interface State extends StoreState {
    cart: ShoppingCart
    config: Config
    locale: Locale
    router: {
        action: string
        location: {
            pathname: string
            search: string
        }
    }
}

export function getAuthoriseStepInternal(state: State) {
    const { cart = {} as ShoppingCart } = state
    const isReadyToOrder = !!cart.x_readyToOrder
    const paymentParams = getPaymentParams(state)

    return {
        paymentParams,
        isReadyToOrder,
    }
}

// Payment params are set on the server when Adyen posts 3DSecure tokens back to us from card issuer.
// Query params are set when Adyen redirects back to us with PayPal tokens.
export function getPaymentParams(state: State) {
    const { paymentParams, router } = state
    return { ...paymentParams, ...parse(router?.location?.search) }
}
